/**
 * 環境毎にAPIのオリジンを変える必要が出てきた時のために、独立したファイルとして定義しています。
 */
export const apiOrigin = typeof window === "undefined" ? "" : window.location.origin
